import { twMerge } from 'tailwind-merge';

import type { TextareaProps } from './type';

export const Textarea = ({ ref, containerProps = {}, label, shrink = true, className, ...props }: TextareaProps) => {
  const { className: containerClassName, ...restContainerProps } = containerProps;

  return (
    <div
      {...restContainerProps}
      className={twMerge('relative flex min-h-16 w-full min-w-20 items-end', containerClassName)}
    >
      <textarea
        ref={ref}
        {...props}
        // !resize-none resize-y
        className={twMerge(
          'peer border-c-border text-c-card-foreground focus:border-primary disabled:border-c-border-muted placeholder-shown:border-c-border w-full resize-none! border-b bg-transparent pt-4 pb-1.5 font-sans text-sm font-normal outline-hidden transition-all focus:outline-0 disabled:resize-none disabled:bg-transparent',
          className
        )}
        placeholder={props.placeholder ?? ' '}
      />
      <label
        className={twMerge(
          "after:content[''] text-c-card-muted after:border-primary peer-placeholder-shown:text-c-card-muted peer-focus:text-primary peer-focus:after:border-primary peer-disabled:text-c-card-muted peer-placeholder-shown:peer-disabled:text-c-card-muted dark:peer-focus:text-primary pointer-events-none absolute top-0 left-0 flex h-full w-full truncate overflow-visible! text-[11px] leading-tight font-normal transition-all select-none peer-placeholder-shown:text-sm peer-placeholder-shown:leading-[4.25] peer-focus:text-[11px] peer-focus:leading-tight after:absolute after:bottom-0 after:block after:w-full after:scale-x-0 after:border-b-2 after:transition-transform after:duration-300 peer-focus:after:scale-x-100 dark:peer-placeholder-shown:text-gray-400 dark:peer-disabled:text-gray-400",
          shrink && 'text-[11px]! leading-tight!'
        )}
      >
        {label}
      </label>
    </div>
  );
};
